// Patrocinadores do torneio.
//
// Todos entram como patrocínio — não existe mais a separação entre "patrocínio"
// e "apoio". Para tirar um do ar sem perder o cadastro, use `active: false`;
// para esconder todos de uma vez (entre edições, por exemplo), use
// `settings.enabled: false`.
export const sponsorsConfig = {
  sponsors: [
    {
      id: 1,
      name: 'Serralheria Maranhão',
      image: '/images/sponsors/serralheria_maranhao.jpg',
      url: 'https://www.instagram.com/serralheria.maranhao/?hl=pt-br',
      description: 'Serralheria Maranhão',
      active: true,
    },
    {
      id: 2,
      name: 'Assis Pinturas',
      image: '/images/sponsors/assis_pinturas.jpg',
      url: 'https://www.instagram.com/assis.pinturas/?hl=pt-br',
      description: 'Assis Pinturas',
      active: true,
    },
    {
      id: 3,
      name: 'TR Assessoria',
      image: '/images/sponsors/tr_assessoria.png',
      url: 'https://trassessoriaeprojetos.com.br/',
      description: 'TR Assessoria e Projetos',
      active: true,
    },
    {
      id: 4,
      name: 'Kota Auditoria',
      image: '/images/sponsors/kota_tecnologia.png',
      url: 'https://www.kota.net.br/',
      description: 'Kota Auditoria',
      active: true,
    },
    {
      id: 5,
      name: 'Tozetti Madeiras',
      image: '/images/sponsors/tozzeti_madeiras.png',
      url: 'https://tozettisia.com.br/',
      description: 'Tozetti Madeiras',
      active: true,
    },
    {
      id: 6,
      name: 'Thumbnails Magnéticas',
      image: '/images/sponsors/thumbnails_magneticas.png',
      url: 'https://thumbnailsmagneticas.com.br?utm_source=site-torneio&utm_medium=patrocinio&utm_campaign=goleiro_raiz&utm_content=banner',
      description: 'Thumbnails Magnéticas',
      active: true,
    },
    {
      id: 7,
      name: 'Psiquê',
      image: '/images/sponsors/psique.png',
      url: 'https://www.instagram.com/psiquebrasilia/',
      description: 'Psiquê Brasília',
      active: true,
    },
  ],

  // Configurações de exibição
  settings: {
    enabled: true, // false esconde todas as seções de patrocinadores do site
    showInactive: false,
  },

  /** Patrocinadores que devem aparecer no site, na ordem da lista acima. */
  getActiveSponsors() {
    return this.sponsors.filter(
      (sponsor) => this.settings.showInactive || sponsor.active,
    );
  },
};
